import { Trans } from '@lingui/react/macro';
import type { FacilityTransferNotePublicRecord } from '@navio/nsdk';
import { NoddiBasicCard } from 'noddi-ui-web';
import { formatOrderSlugs } from './formatOrderSlugs';

interface Props {
  notes: FacilityTransferNotePublicRecord[];
}

export const OrderNotes = ({ notes }: Props) => {
  // The same note is often written on every order of the day; show it once with all its orders.
  const mergedNotes = notes.reduce<{ comment: string; orderSlugs: string[] }[]>((merged, note) => {
    const comment = note.comment.trim();
    const same = merged.find((entry) => entry.comment === comment);
    if (same) {
      same.orderSlugs.push(note.orderSlug);
    } else {
      merged.push({ comment, orderSlugs: [note.orderSlug] });
    }
    return merged;
  }, []);

  if (mergedNotes.length === 0) {
    return null;
  }
  return (
    <NoddiBasicCard className='flex flex-col gap-2'>
      <h2 className='text-sm font-semibold'>
        <Trans>Notes</Trans>
      </h2>
      <ul className='flex flex-col gap-1 text-sm'>
        {mergedNotes.map((note) => (
          <li key={note.comment}>
            <span className='mr-1 text-xs text-muted-foreground uppercase'>{formatOrderSlugs(note.orderSlugs)}</span>
            <span className='whitespace-pre-wrap'>{note.comment}</span>
          </li>
        ))}
      </ul>
    </NoddiBasicCard>
  );
};
